import React, { Component } from 'react';

import './style.scss';

class NoContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            callUsStatus: false
        }
    }

    render() {
        let { msg } = this.props;
        return (
            <div className='no-content no-results container-930'><h3>{msg ? msg : 'No result found!!'}</h3></div>
        );
    }
}

export default NoContent;
